(function () {
  "use strict";
  function init() {
    const root = document.getElementById("pl-family-finder");
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";
    const options = Array.from(root.querySelectorAll(".pl-family-option"));
    const known = new Map(options.map(button => [button.dataset.family, button]));
    const countNodes = root.querySelectorAll("[data-count-for]");
    const selectedText = document.getElementById("pl-family-selection");
    const clearButton = document.getElementById("pl-family-clear");
    const modePanel = document.getElementById("pl-family-match-options");
    const modeRadios = Array.from(root.querySelectorAll('input[name="pl-family-mode"]'));
    const totalText = document.getElementById("pl-family-result-count");
    const resultsHeading = document.getElementById("pl-family-result-heading");
    const status = document.getElementById("pl-family-status");
    const grid = document.getElementById("pl-family-results");
    const pagination = document.getElementById("pl-family-pagination");
    const previous = document.getElementById("pl-family-previous");
    const next = document.getElementById("pl-family-next");
    const pageCount = document.getElementById("pl-family-page-count");
    const PAGE_SIZE = 10;
    const siteRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    const search = new URLSearchParams(window.location.search);
    const initialFamilies = [];
    if (search.get("families")) {
      search.get("families").split(",").forEach(f => initialFamilies.push(f.trim().toLowerCase()));
    } else if (search.get("family")) {
      initialFamilies.push(search.get("family").trim().toLowerCase());
    }
    let selected = [...new Set(initialFamilies)].filter(f => known.has(f));
    // Only product-page family links set this flag. Menu visits stay at the finder top.
    let openedFromProduct = search.get("from_product") === "1" && selected.length === 1;
    let pendingProductScroll = openedFromProduct;
    let mode = selected.length === 2 && search.get("match") === "both" ? "both" : "any";
    let products = [];
    let loaded = false;
    let failed = false;
    let resultPage = 1;
    const familyName = id => (known.get(id)?.querySelector(".pl-family-option-name")?.textContent || id);
    const add = (tag, className, value) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    };
    function updateUrl() {
      const params = new URLSearchParams(window.location.search);
      params.delete("family");
      params.delete("families");
      params.delete("match");
      params.delete("from_product");
      if (selected.length === 1) params.set("family", selected[0]);
      if (selected.length > 1) params.set("families", selected.join(","));
      if (selected.length === 2 && mode === "both") params.set("match", "both");
      const nextUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
      window.history.replaceState(window.history.state, "", nextUrl);
    }
    function updateControls() {
      // Product-link results show the clicked family; manual searches keep the generic title.
      if (resultsHeading) resultsHeading.textContent = openedFromProduct && selected.length === 1
        ? "Matching " + familyName(selected[0]) + " fragrances"
        : "Matching fragrances";
      options.forEach(button => button.setAttribute("aria-pressed", String(selected.includes(button.dataset.family))));
      selectedText.textContent = selected.length === 0 ? "Choose a family to explore" : selected.length + (selected.length === 1 ? " family selected" : " families selected");
      clearButton.disabled = selected.length === 0;
      modePanel.hidden = selected.length !== 2;
      modeRadios.forEach(input => { input.checked = input.value === mode; });
    }
    function setStatus(head, message, symbol) {
      status.replaceChildren();
      status.appendChild(add("span", "pl-family-empty-icon", symbol || "✦"));
      status.appendChild(add("strong", "", head));
      status.appendChild(add("span", "", message));
      status.hidden = false;
      grid.hidden = true;
      pagination.hidden = true;
    }
    function score(product) {
      return (selected.includes(product.primary_family) ? 5 : 0) + (selected.includes(product.secondary_family) ? 2 : 0);
    }
    function matchingProducts() {
      if (!selected.length) return [];
      return products.filter(product => {
        const families = [product.primary_family, product.secondary_family];
        return mode === "both" && selected.length === 2
          ? selected.every(f => families.includes(f))
          : selected.some(f => families.includes(f));
      }).sort((a, b) => score(b) - score(a) || a.title.localeCompare(b.title));
    }
    function productCard(product) {
      const link = add("a", "pl-family-product");
      link.href = siteRoot + "products/" + encodeURIComponent(product.handle);
      const photo = add("div", "pl-family-product-image");
      if (product.image) {
        const img = add("img");
        img.src = product.image;
        img.alt = product.title;
        img.loading = "lazy";
        img.decoding = "async";
        photo.appendChild(img);
      }
      link.appendChild(photo);
      const body = add("div", "pl-family-product-content");
      body.appendChild(add("h3", "", product.title));
      const tags = add("div", "pl-family-product-meta");
      tags.appendChild(add("span", "pl-family-tag primary", "Primary: " + familyName(product.primary_family)));
      if (product.secondary_family && product.secondary_family !== product.primary_family) {
        tags.appendChild(add("span", "pl-family-tag", "Secondary: " + familyName(product.secondary_family)));
      }
      body.appendChild(tags);
      const bottom = add("div", "pl-family-product-bottom");
      if (product.price) bottom.appendChild(add("div", "pl-family-price", "From " + product.price));
      bottom.appendChild(add("div", "pl-family-view", "View sample →"));
      body.appendChild(bottom);
      link.appendChild(body);
      return link;
    }
    function renderResults() {
      updateControls();
      if (failed) {
        totalText.textContent = "Unable to load fragrance samples.";
        setStatus("Unable to load samples", "Please refresh this page to try again.", "!");
        return;
      }
      if (!loaded) {
        totalText.textContent = "Loading sample fragrances…";
        setStatus("Loading fragrances", "Preparing matching perfume samples and family counts.", "…");
        return;
      }
      if (!selected.length) {
        totalText.textContent = "Select a family above to see matching samples.";
        setStatus("Start with a family you love", "Choose a scent style above to see matching perfumes.");
        return;
      }
      const results = matchingProducts();
      totalText.textContent = results.length + (results.length === 1 ? " sample fragrance found" : " sample fragrances found") + (mode === "both" && selected.length === 2 ? " · matching both families" : "");
      if (!results.length) {
        setStatus("No matching perfumes", "Try selecting a different family, or choose “Either family”.", "○");
        return;
      }
      status.hidden = true;
      grid.hidden = false;
      const pages = Math.ceil(results.length / PAGE_SIZE);
      resultPage = Math.max(1, Math.min(resultPage, pages));
      grid.replaceChildren();
      results.slice((resultPage - 1) * PAGE_SIZE, resultPage * PAGE_SIZE).forEach(product => grid.appendChild(productCard(product)));
      pagination.hidden = pages < 2;
      pageCount.textContent = "Page " + resultPage + " of " + pages;
      previous.disabled = resultPage <= 1;
      next.disabled = resultPage >= pages;
    }
    function scrollToProductMatches() {
      if (!pendingProductScroll || !loaded || selected.length !== 1) return;
      pendingProductScroll = false;
      const results = root.querySelector(".pl-family-result-section");
      if (!results) return;
      window.requestAnimationFrame(() => {
        const reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        results.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
      });
    }
    function updateCounts() {
      const counts = new Map(Array.from(known.keys()).map(k => [k, 0]));
      for (const p of products) {
        for (const f of new Set([p.primary_family, p.secondary_family])) {
          if (counts.has(f)) counts.set(f, counts.get(f) + 1);
        }
      }
      countNodes.forEach(el => {
        const num = counts.get(el.dataset.countFor) || 0;
        el.textContent = num + (num === 1 ? " fragrance" : " fragrances");
      });
    }
    async function fetchSamples() {
      const result = [];
      const seen = new Set();
      const previewId = new URLSearchParams(window.location.search).get("preview_theme_id");
      for (let page = 1; page <= 100; page++) {
        const url = new URL(siteRoot + "collections/all", window.location.origin);
        url.searchParams.set("section_id", "pl-finder-data");
        url.searchParams.set("page", String(page));
        if (previewId) url.searchParams.set("preview_theme_id", previewId);
        const response = await fetch(url.toString(), { credentials: "same-origin" });
        if (!response.ok) throw new Error("HTTP " + response.status);
        const doc = new DOMParser().parseFromString(await response.text(), "text/html");
        const payload = doc.querySelector("[data-pl-finder-payload]");
        if (!payload) throw new Error("Missing family data in theme preview");
        const data = JSON.parse(payload.textContent);
        if (!Array.isArray(data.products) || !Number.isFinite(Number(data.pages))) throw new Error("Invalid finder data");
        for (const p of data.products) {
          if (!p || !p.handle || seen.has(p.handle)) continue;
          const tags = Array.isArray(p.tags) ? p.tags.map(x => String(x).toLowerCase()) : [];
          if (!tags.includes("sample") || tags.includes("full-bottle")) continue;
          seen.add(p.handle);
          result.push({
            title: String(p.title || ""),
            handle: String(p.handle),
            image: typeof p.image === "string" ? p.image : "",
            price: typeof p.price === "string" ? p.price : "",
            primary_family: String(p.primary_family || "").toLowerCase(),
            secondary_family: String(p.secondary_family || "").toLowerCase()
          });
        }
        if (page >= Number(data.pages)) return result;
      }
      throw new Error("Finder pagination safety limit exceeded");
    }
    options.forEach(button => button.addEventListener("click", () => {
      // A manual selection ends the one-time product-link mode.
      openedFromProduct = false;
      pendingProductScroll = false;
      const value = button.dataset.family;
      selected = selected.includes(value) ? selected.filter(x => x !== value) : [...selected, value];
      if (selected.length !== 2) mode = "any";
      resultPage = 1;
      updateUrl();
      renderResults();
    }));
    clearButton.addEventListener("click", () => {
      openedFromProduct = false;
      pendingProductScroll = false;
      selected = [];
      mode = "any";
      resultPage = 1;
      updateUrl();
      renderResults();
    });
    modeRadios.forEach(input => input.addEventListener("change", () => {
      if (input.checked) {
        openedFromProduct = false;
        pendingProductScroll = false;
        mode = input.value === "both" && selected.length === 2 ? "both" : "any";
        resultPage = 1;
        updateUrl();
        renderResults();
      }
    }));
    previous.addEventListener("click", () => {
      if (resultPage <= 1) return;
      resultPage -= 1;
      renderResults();
      root.querySelector(".pl-family-result-section")?.scrollIntoView({ block: "start", behavior: "smooth" });
    });
    next.addEventListener("click", () => {
      resultPage += 1;
      renderResults();
      root.querySelector(".pl-family-result-section")?.scrollIntoView({ block: "start", behavior: "smooth" });
    });
    renderResults();
    fetchSamples().then(data => {
      products = data;
      loaded = true;
      updateCounts();
      renderResults();
      scrollToProductMatches();
    }).catch(error => {
      console.error("Perfume Library family finder:", error);
      failed = true;
      countNodes.forEach(el => { el.textContent = "Count unavailable"; });
      renderResults();
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();